import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
      <Box>
        {typeof title === 'string' ? (
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{title}</Typography>
        ) : (
          title
        )}
        {subtitle && (
          <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {actions}
      </Box>
    </Box>
  );
};

export default PageHeader;
